import classNames from 'classnames';
import { useEffect, useRef } from 'react';
import PropTypes from 'prop-types';
import { Element } from 'react-scroll';

export const Card = ({ children, isActived, onActiveQuestion, ...props }) => {
    const questionRef = useRef(null);
    useEffect(() => {
        if (isActived) {
            onActiveQuestion(questionRef);
        }
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [isActived]);

    return (
        <div
            id={props.id}
            ref={questionRef}
            role="button"
            className={classNames(
                'rounded-lg shadow-lg bg-white w-full border-2 transition-all duration-300',
                {
                    'border-[#312966]': props.selectId === props.id,
                    'border-white': props.selectId !== props.id,
                }
            )}
            onClick={props.onClick}
        >
            <Element id={props.id} />
            {children}
        </div>
    );
};

Card.propTypes = {
    children: PropTypes.node,
    isActived: PropTypes.bool.isRequired,
    onActiveQuestion: PropTypes.func.isRequired,
    id: PropTypes.string.isRequired,
    selectId: PropTypes.string.isRequired,
    onClick: PropTypes.func.isRequired,
};
